import { isNil } from 'lodash'

import { cloudhelpGet } from 'Utilities/CloudHelp'

function getServiceCategoryOptions(serviceCategories = [], ticketTypeId, guestUser) {
  let categories = serviceCategories.filter(serviceCategory => isNil(serviceCategory.parent_id))

  if (!guestUser) {
    categories = categories.filter(({ ticket_type_id }) => ticket_type_id === ticketTypeId)
  }

  return categories.map(({ id, name }) => ({ value: id, label: name }))
}

function getServiceSubCategoryOptions(serviceCategories = [], service_category_id, ticketTypeId, guestUser) {
  let categories = serviceCategories.filter(({ parent_id }) => !isNil(parent_id) && parent_id === service_category_id)

  if (!guestUser) {
    categories = categories.filter(({ ticket_type_id }) => ticket_type_id === ticketTypeId)
  }

  return categories.map(({ id, name }) => ({ value: id, label: name }))
}

function setOptions({ options, setContractOptions, customer_contract_id, service_id, setServiceOptions, setServiceCategories, }) {
  const contract = options.find(o => o.value === customer_contract_id);
  const serviceOptions = (contract?.options || []);
  const service = serviceOptions.find(o => o.value === service_id);

  setContractOptions(options);
  setServiceOptions(serviceOptions);
  setServiceCategories(service?.service_categories || []);
}

function fetchContractsAndServices({ clientId, setContractSelectOptions, setAlert, setIsLoading }) {
  if (clientId) {
    setIsLoading(true)
    const controller = new AbortController();
    const { signal } = controller;

    cloudhelpGet(`/api/clients/${clientId}/customer_contracts`)
        .then(({ data = [] }) => setContractSelectOptions(data))
        .catch((e) => {
          console.log(e);
          setAlert({ show: true, title: 'There was an issue getting your contracted services.' });
        })
        .finally(() => setIsLoading(false));

    return () => controller.abort();
  }
}

export { setOptions, fetchContractsAndServices, getServiceCategoryOptions, getServiceSubCategoryOptions }
